import React from 'react'
import BrickWall from '../../assets/Brick_Wall.svg'
import SelfPacedVideos from '../../assets/Self_Paced_Videos.svg'
import SequenceButtons from '../../assets/Sequence_Buttons.svg'
import '../../styles/pseudocode.css'

const Section2 = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: "100px" }}>
        <div className='px-3 text-center scroll-fade-in'>
            <h2>What you can expect</h2>
            <p>We can't do the work for you, but we'll give you the tools you need to build.</p>
        </div>
        <div className='d-flex flex-wrap justify-content-center gap-4 pt-4'>
            <div className="bg-black rounded col-10 col-md-8 col-lg-3 col-fade-in-1" style={{border: "1px solid white"}}>
                <img src={BrickWall} style={{width: '100%', objectFit: 'cover'}} alt="Brick Wall" />
                <div style={{padding: "0 20px 20px"}}>
                    <h4>Core concepts covered</h4>
                    <p>Get all the building blocks you need to be proficient in today's meta.</p>
                </div>
            </div>
            <div className="bg-black rounded col-10 col-md-8 col-lg-3 col-fade-in-2" style={{border: "1px solid white"}}>
                <img src={SelfPacedVideos} style={{width: '100%', objectFit: 'cover'}} alt="Self Paced Videos" />
                <div style={{padding: "0 20px 20px"}}>
                    <h4>Self-paced video courses</h4>
                    <p className='m-0'>Whether you dash like Bowser or Falcon, this course is perfectly your speed.</p>
                </div>
            </div>
            <div className="bg-black rounded col-10 col-md-8 col-lg-3 col-fade-in-3" style={{border: "1px solid white"}}>
                <img src={SequenceButtons} style={{width: '100%', objectFit: 'cover'}} alt="Sequence Buttons" />
                <div style={{padding: "0 20px 20px"}}>
                    <h4>Practice Guides</h4>
                    <p>Take your newfound foundation and apply them to the rest of your skillset.</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Section2